import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import renderCellExpand from "../../components/renderCellExpand";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import red from "@material-ui/core/colors/red";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import { CircularProgress } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import ShowAlert from "../../components/ShowAlert";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useBrowserContextCommunication from "react-window-communication-hook";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import DescriptionIcon from "@material-ui/icons/Description";
import ContractInfoForm from "../../components/staff/ContractInfoForm";
import UploadDocument from "../../components/UploadDocument";
// Services
import { hisServices } from "../../services/hisServices";
import { staffAppointmentService } from "../../services/staff/staffAppointmentService";
import { appointmentService } from "../../services/appointmentService";
//Mapeo de clinicas
import { clinicsM } from "../../services/clinicsM";
import Lottie from "lottie-react";
import listo from "../../assets/static/gestion.json";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 4, 3),
  },
  field: {
    width: "100%",
    marginTop: "2px",
  },
  grid: {
    height: "0px",
    marginLeft: "92%",
  },
  principalCont: {
    paddingLeft: "20px",
    paddingTop: "20px",
    paddingBottom: "20px",
    paddingRight: "20px",
  },
  principalCont1: {
    paddingLeft: "10px",
    paddingTop: "1px",
    paddingBottom: "10px",
    paddingRight: "10px",
  },
  principalCont2: {
    paddingLeft: "10px",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingRight: "10px",
  },
}));

const GestionModal = (props) => {
  const classes = useStyles();
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  const [formDataDocument, setFormDataDocument] = useState(false);
  const [status, setStatus] = useState(props.paramsRowIncapacity?.estado);
  const [allStatus, setAllStatus] = useState([
    "TRAMITE INTERNO",
    "RADICADO POR LA EPS",
  ]);
  const [communicationState, postMessage] = useBrowserContextCommunication(
    "DashboardStaffChanel"
  );
  const [disabledModal, setDisabledModal] = useState(false);
  const [description, setDescription] = useState("");
  const [alert, handleAlert] = useState({
    show: false,
    type: null,
    title: null,
    message: null,
    strong: null,
    action: null,
  });

  const [clinicalHistory, setClinicalHistory] = useState("");
  const [formulaMedica, setFormulaMedica] = useState("");
  const [incapacidad, setIncapacidad] = useState("");
  const [ordenes, setOrdenes] = useState("");
  const [observacion, setObservacion] = useState("");
  //nuevos botones para los documentos
  const [consultas, setConsultas] = useState("");
  const [estancias, setEstancias] = useState("");
  const [imagenDiagnostica, setImagenDiagnostica] = useState("");
  const [laboratorio, setLaboratorio] = useState("");
  const [terapia, setTerapia] = useState("");
  const [procNoQuirurgicos, setProcNoQuirurgicos] = useState("");
  const [procQuirurgicos, setProcQuirurgicos] = useState("");
  const [otros, setOtros] = useState("");
  const [inmunizaciones, setInmunizaciones] = useState("");

  const clinicsMaping = clinicsM.Maping();

  const [notifyLoading, setNotifyLoading] = useState(false);
  const [notificationForm, setNotificationForm] = useState({
    title: "",
    message: "",
  });
  const [open, setOpen] = useState(false);

  //Dialog Functions
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNotifyTextInput = (event) => {
    setNotificationForm({
      ...notificationForm,
      [event.target.name]: event.target.value,
    });
  };

  const observacionInput = (event) => {
    setObservacion(event.target.value);
  };

  const handleOpenDialogForm = (action) => {
    if (action === "Recordar") {
      setNotificationForm({
        ...notificationForm,
        title: "Reclamar medicamentos",
        message: `Ya puede reclamar los siguientes medicamentos, paracetamol, en la siguiente dirección: Av. 6N #18N-44 Versalles, Audifarma`,
      });
    }
    setOpen(true);
  };

  const handleNotify = async () => {
    const cardId = props.paramsRowMedicalOrders?.CitCed?.trim();
    const extra = null;
    try {
      setNotifyLoading(true);
      const resp = await staffAppointmentService.notifyToCardId(
        cardId,
        "CC",
        notificationForm.title,
        notificationForm.message,
        extra
      );
      console.log("respuesta", resp);
      setNotifyLoading(false);
      handleClose(); //close alert dialog
      handleAlert({
        ...alert,
        show: true,
        type: "success",
        message: ``,
        strong: "Notificación enviada correctamente",
      });
      setTimeout(() => handleAlert({ ...alert, show: false }), 5000);
    } catch (error) {
      handleAlert({
        ...alert,
        show: true,
        type: "error",
        message: ``,
        strong: "Error enviando notificación, inténtelo nuevamente",
      });
      setTimeout(() => handleAlert({ ...alert, show: false }), 5000);

      console.log(error);
      setNotifyLoading(false);
    }
  }; //end Dialog functions

  useEffect(() => {
    /* setClinicalHistory("");
    setIncapacidad("");
    setOrdenes("");
    setFormulaMedica("");
    setConsultas("");
    setEstancias("");
    setImagenDiagnostica("");
    setLaboratorio("");
    setTerapia("");
    setProcNoQuirurgicos("");
    setProcQuirurgicos("");
    setOtros("");
    setInmunizaciones("");

    handleGetDocumentsAppointments(
      props.clinic.cli_id,
      props.paramsRowMedicalOrders?.CitCed?.trim(),
      props.paramsRowMedicalOrders.CitNum
    );
    console.log("datos handleGetDocumentsAppointments", props);
    setDisabledModal(false); */
  }, [props.paramsRowMedicalOrders?.CitNum]);

  const handleCloseButton = () => {
    setCloseModal(true);
    setDisabledModal(false);
    //setStatus('TRAMITE INTERNO');
    setDescription("");
    props.GestionModal();
    postMessage({
      PriorityStatusChanged: true,
    });
  };

  const GestionOrdenamiento = async () => {
    console.log(
      "props.paramsRowMedicalOrders",
      props?.paramsRowGestionModal?.priorityPetitionApointmentId
    );

    try {
      await staffAppointmentService.changePriorityPetitionAppointmentStatus(
        props?.paramsRowGestionModal?.priorityPetitionApointmentId,
        "AUTORIZADO",
        "AUTORIZADO"
      );
      setCloseModal(true);
      setDisabledModal(false);
      //getAllPriorityPetitionApointments();
      props.GestionModal();
      postMessage({
        PriorityStatusChanged: true,
      });
    } catch {
      console.log("respuesta error");
    }

    //console.log("respuesta", resp);
    //console.log("datos a enviar", datos);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={props.open}
      onClose={props.GestionModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <Fade in={props.open}>
        <Grid
          direction="column"
          justify="center"
          alignItems="stretch"
          spacing={1}
        >
          <Grid className={classes.grid}>
            <IconButton
              edge="start"
              size="medium"
              onClick={() => handleCloseButton()}
              color="primary"
            >
              <CloseIcon style={{ color: red[400] }} />
            </IconButton>
          </Grid>
          <Paper variant="outlined" className={classes.principalCont}>
            <Container component="main" maxWidth="sm" spacing={3}>
              <div style={{ width: "100%", marginBottom: "5px" }}>
                {" "}
                {alert.show && <ShowAlert {...alert} />}
              </div>
              <Grid
                container
                direction="column"
                justify="space-evenly"
                alignItems="stretch"
                spacing={2}
              >
                <Grid item style={{ marginTop: 5 }}>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item>
                      <Typography component="h4">
                        <strong>Gestionar Paciente</strong>
                      </Typography>
                    </Grid>
                    {/* <Lottie animationData={listo} /> */}
                    <Grid item>
                      <Typography component="h4">
                        <strong>
                          Al gestionar se enviara una notificacion al paciente
                          de esta accion.
                        </strong>
                      </Typography>
                    </Grid>
                    <Button
                      style={{ marginLeft: 7 }}
                      size="small"
                      disabled={disabledModal || loadingDocument}
                      variant="contained"
                      color="primary"
                      onClick={() => GestionOrdenamiento()}
                    >
                      Gestionar
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </Paper>
        </Grid>
      </Fade>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  lastContrat: state.lastContrat,
  clinic: state.clinic,
});

export default connect(mapStateToProps, null)(GestionModal);
